import angular from 'angular';
import { postImageAreaComponent } from './postImageAreaComponent';

import 'components/sharpr/post/image/postImageModule';

angular.module('sh.postImageArea', ['sh.postImage']).component('shPostImageArea', postImageAreaComponent());
